import { Copy } from '../copy/Copy';
import { Marketing } from '../icons/Marketing/Marketing';
import { Contract } from '../icons/Contract/Contract';
import { Teach } from '../icons/Teach/Teach';
import { Photo } from '../icons/Photo/Photo';
import { Support } from '../icons/Support/Support';
import { Studio } from '../icons/Studio/Studio';

export const FEATURES = [
  {
    icon: Support,
    heading: Copy.generate('Home.features.list.1.title'),
    content: Copy.generate('Home.features.list.1.content'),
  },
  {
    icon: Teach,
    heading: Copy.generate('Home.features.list.2.title'),
    content: Copy.generate('Home.features.list.2.content'),
  },
  {
    icon: Marketing,
    heading: Copy.generate('Home.features.list.3.title'),
    content: Copy.generate('Home.features.list.3.content'),
  },
  {
    icon: Studio,
    heading: Copy.generate('Home.features.list.4.title'),
    content: Copy.generate('Home.features.list.4.content'),
  },
  {
    icon: Photo,
    heading: Copy.generate('Home.features.list.5.title'),
    content: Copy.generate('Home.features.list.5.content'),
  },
  {
    icon: Contract,
    heading: Copy.generate('Home.features.list.6.title'),
    content: Copy.generate('Home.features.list.6.content'),
  },
];
